/**
 * [Small viewport-percentage units](https://www.w3.org/TR/css-values-4/#small-viewport-percentage-units)
 */
const doSvh = () =>
  document.documentElement.style.setProperty(
    "--svh",
    `${window.innerHeight * 0.01}px`
  );

window.addEventListener("resize", doSvh);
window.addEventListener("load", doSvh);
doSvh();
